//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { changePassword as _changePassword } from "@/api/usercontrol";
export default {
  data: function data() {
    var _this = this;

    var VerificationPassword = function VerificationPassword(rule, value, callback) {
      var password = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,16}$/;

      if (password.test(value) == false) {
        return callback(new Error(_this.$t('lang.usercontrol.errmessage2')));
      } else {
        callback();
      }
    };

    var reCheckPassword = function reCheckPassword(rule, value, callback) {
      if (value !== _this.newpass.newpassword) {
        return callback(new Error(_this.$t('lang.usercontrol.errmessage6')));
      } else {
        callback();
      }
    };

    return {
      dialogVisible: false,
      newpass: {
        user_id: null,
        newpassword: "",
        affirmpassword: ""
      },
      inputType: 'password',
      rules: {
        newpassword: [{
          required: true,
          validator: VerificationPassword,
          trigger: 'blur'
        }],
        affirmpassword: [{
          required: true,
          validator: reCheckPassword,
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    show: function show(user_id) {
      this.newpass = {
        user_id: null,
        newpassword: "",
        affirmpassword: ""
      };
      this.newpass.user_id = user_id;
      this.dialogVisible = true;
    },
    changePassword: function changePassword() {
      var _this2 = this;

      this.$refs.editPwd.validate(function (valid) {
        if (valid) {
          _changePassword(_this2.newpass.user_id, _this2.newpass.newpassword).then(function (res) {
            if (res.data.code === 0) {
              _this2.$message({
                showClose: true,
                message: _this2.$t("lang.usercontrol.message9"),
                type: "success"
              });

              _this2.$emit('queryKeyword');

              _this2.dialogVisible = false;
            } else if (res.data.code === 11) {
              _this2.$message({
                showClose: true,
                message: _this2.$t("lang.usercontrol.message10"),
                type: "error"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //设置密码是否显示
    viewPwd: function viewPwd() {
      if (this.inputType === 'password') {
        this.inputType = '';
      } else {
        this.inputType = 'password';
      }
    }
  }
};